import { render, staticRenderFns } from "./SuficienciaMovimientosList.vue?vue&type=template&id=36fb25e8&"
import script from "./SuficienciaMovimientosList.vue?vue&type=script&lang=js&"
export * from "./SuficienciaMovimientosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports